import React from "react";
import Table from "@/shared/components/organisms/Table";
import ColumnPersonalInformation from "@/shared/components/molecules/ColumnPersonalInformation";
import ColumnTask from "@/shared/components/molecules/ColumnTask";
import ColumnDate from "@/shared/components/molecules/ColumnDate";
import ColumnDropdown from "@/shared/components/molecules/ColumnDropdown";
import ColumnLabels from "@/shared/components/molecules/ColumnLabels";
import ColumnButton from "@/shared/components/molecules/ColumnButton";
import ColumnTitleDate from "@/shared/components/molecules/ColumnTitleDate";
import { getOptionsStatusBusiness } from "@/shared/constants/constants";

type PersonProps = {
  name: string;
  email: string;
  phone: string;
  company: string;
  campaign?: string;
  date: string;
  task: string;
  dateTask: string;
  businessStage: string;
  labels: string[];
};

const TableListCatchment: React.FC<{
  people: PersonProps[];
  branchId: string;
  createUser: (user: any) => void;
}> = ({ people, createUser, branchId }) => {
  const optionsStatusBusiness = getOptionsStatusBusiness();

  const handleClick_name = (person: { id: string }) => {
    const url = `/leads/${person?.id}/?branch_id=${branchId}`;
    window.open(url, "_blank");
  };

  const columns = [
    {
      header: "Leads",
      accessor: "name",
      render: (person: PersonProps) => (
        <ColumnPersonalInformation
          onNameClick={() => handleClick_name(person)}
          name={person?.name}
          email={person?.email}
          phone={person?.phone}
        />
      ),
    },
    {
      header: "Campaña / Fecha Creacion",
      accessor: "campaign",
      render: (person: PersonProps) =>
        person?.campaign !== null ||
        person?.campaign !== "" ||
        person?.campaign !== undefined ? (
          <ColumnTitleDate title={person?.campaign} date={person?.created_at} />
        ) : (
          <ColumnDate date={person?.date} />
        ),
    },
    {
      header: "Etapas del negocio",
      accessor: "businessStage",
      render: (person: PersonProps) => (
        <ColumnDropdown
          lastPeople={people} // Last people
          person={person}
          selected={person.businessStage}
          options={optionsStatusBusiness}
        />
      ),
    },
    {
      header: "Etiquetas marketing",
      accessor: "labels",
      render: (person: PersonProps) => <ColumnLabels labels={person.labels} />,
    },
    {
      header: "Tareas",
      accessor: "task",
      render: (person: PersonProps) => {
        if (!person.task || !person.dateTask) return null;

        return <ColumnTask task={person.task} date={person.dateTask} />;
      },
    },

    {
      header: "",
      accessor: "email",
      render: (person: PersonProps) => (
        <ColumnButton
          name="Convertir en cliente"
          action={() => createUser?.(person)}
        />
      ),
    },
  ];

  return <Table data={people} columns={columns as any} />;
};

export default TableListCatchment;
